<template>
    <div
      style="padding: 10px 10px 10px 0; page-break-before: auto; page-break-after: always"
    >
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <div class="flex sb">
          <div>
            <el-form-item label="商铺号">
              <el-select
                filterable
                size="small"
                v-model="form.shopNum"
                placeholder="请选择商铺号"
                clearable
                style="width: 150px"
              >
                <el-option
                  v-for="item in shopList"
                  :label="item.shopNum"
                  :value="item.shopNum"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商铺名称">
              <el-select
                filterable
                size="small"
                v-model="form.shopName"
                placeholder="请选择商铺名称"
                clearable
                style="width: 240px"
              >
                <el-option
                  v-for="item in shopList"
                  :label="item.brandName"
                  :value="item.brandName"
                ></el-option>
              </el-select>
            </el-form-item>
            
            <el-form-item label="租金收取方式">
              <el-select
                clearable
                size="small"
                v-model="form.mode"
                placeholder="租金收取方式"
                style="width: 130px"
              >
                <el-option label="固定租金" value="固定租金"></el-option>
                <el-option label="提成租金" value="提成租金"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出账年月">
                <el-date-picker
                  size="small"
                  type="monthrange"
                  value-format="yyyy-MM"
                  range-separator="至"
                  start-placeholder="开始年月"
                  end-placeholder="结束年月"
                  :clearable="false"
                  v-model="queryDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item> 
              <el-form-item label="筛选">  
                <el-checkbox-group v-model="form.clownes">  
                  <el-checkbox  
                    v-for="clown in clownes"  
                    :key="clown.value"  
                    :label="clown.value">  
                    {{ clown.label }}  
                  </el-checkbox>  
                </el-checkbox-group>  
              </el-form-item>  
            <el-form-item>
              <el-button type="primary" size="small" @click="dc">导出</el-button>
            </el-form-item>
          </div>
        </div>
        <div>{{ tongjiJson }}</div>
      </el-form>
      <!-- <el-table
        :data="data"
        style="width: 100%"
        v-loading="loading"
      > -->
        <!-- <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="商铺号" prop="shopNum" align="center"> </el-table-column>
        <el-table-column label="商铺名称" prop="shopName" align="center"> </el-table-column>
        <el-table-column label="账期时间" prop="appdate" align="center" width="200">
          <template slot-scope="{ row }">
            <span>{{ row.paymentDay }}</span>
          </template>
        </el-table-column>
        <el-table-column label="租金" prop="money" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.comment" style="color: #101dfa">
              {{ parseFloat(row.money).toFixed(2) }}
            </div>
            <div v-else>
              <span :style="row.status == '已缴费' ? 'color:#30C25B' : 'color:red'">
                {{ parseFloat(row.money).toFixed(2) }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物业费" prop="wuyepay" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.remarkWy" style="color: #101dfa">
              {{ row.wuyepay }}
            </div>
            <div v-else>
              <span :style="row.wuyeStatus == '1' ? 'color:#30C25B' : 'color:red'">
                {{ row.wuyepay }}</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column label="推广费" prop="promotionSum" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.remarkTg" style="color: #101dfa">
              {{ row.promotionSum }}
            </div>
            <div v-else>
              <span :style="row.promotionStatus == '1' ? 'color:#30C25B' : 'color:red'">
                {{ row.promotionSum }}</span
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="count > 0"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="form.pageSize"
        :current-page.sync="form.currentPage"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :total="count"
      >
      </el-pagination> -->
    </div>
  </template>
  
  <script>
  import publicExport from "../../../assets/js/publicExport.js";
  export default {
    data() {
      return {
        rowTome: "",
        isAdd: true,
        comKey: true,
        queryDate: [],
        loading: false,
        sum: 0,
        count: 0,
        isDyxs: true,
        users: [], //申请人
        show: false,
        status: "",
        id: "",
        bdShopPayList: [],
        timeOther: [],
        form: {
          payOrNot: "未对账",
          startDate: "", //申请人id
          endDate: "", //联系电话
          result: "", //状态
          shopName: "", //商铺名称
          shopNum: "", //商铺号
          type: "", //类型（正常，违规）
          currentPage: 1,
          pageSize: 10,
          mode: "",
          clownes:[]
        },
        clownes: [
           { label: '楼层', value: '1' }, 
           { label: '业态', value: '2' },  
           { label: '面积', value: '3' },  
           { label: '开业时间', value: '4' },  
           { label: '支付方式', value: '5' },            
           { label: '租金单价（元/㎡/日)', value: '6' },  
           { label: '物业费单价（元/㎡/日）', value: '7' },  
           { label: '推广费单价（元/㎡/日）', value: '8' },  
           { label: '租金（元/月）', value: '9' },  
           { label: '物业费（元/月）', value: '10' },  
           { label: '推广费（元/月）', value: '11' },  
           { label: '备注', value: '12' } 
         ],
        addForm: {},
        data: [],
        obj: {
          fileRes: "",
          applyTime: "",
        }, //详情数据
        isChange: false,
        show2: false, //控制筛选列的多选框
        oneRow: "", //当checkList列表只有一项时,选择框不可点击
        roleId: "",
        paymentBillVos: [],
        shopList: [],
        tongjiJson: ""
      };
    },
    created() {
      this.roleId = localStorage.roleId;
      this.setMonth();
  
      this.getShopList();
      // this.getAll();
    },
    methods: {
      getShopList() {
        let selectForm = {
          currentPage: 1,
          pageSize: 1000,
        };
        this.$http.post("/api/bdShop/queryShop", selectForm).then((res) => {
          this.shopList = res.data.data.items;
        });
      },
      query() {
        this.form.currentPage = 1;
        this.getAll();
      },
      setMonth() {
        let year = new Date().getFullYear();
        let mon = new Date().getMonth() + 1;
        mon = mon;
        if (mon <= 0) {
          year = year - 1;
          mon = mon + 12;
        }
        if (mon < 10) {
          mon = "0" + mon;
        }
        let queryMonth = year + "-" + mon;
        this.queryDate = [queryMonth, queryMonth];
      },
      changeRow(obj) {
        this.id = obj.id;
        this.status = obj.status;
        this.isChange = true;
      },
      handleCurrentChange(val) {
        this.form.currentPage = val;
        this.getAll();
      },
      handleSizeChange(val) {
        this.form.pageSize = val;
        this.getAll();
      },
      dc() {
        if (this.queryDate && this.queryDate.length == 2) {
          this.form.startDate = this.queryDate[0];
          this.form.endDate = this.queryDate[1];
        } else {
          this.form.startDate = "";
          this.form.endDate = "";
        }
        const obj = {
            beginTime: this.form.startDate,
            endTime: this.form.endDate,
            shopCode: this.form.shopNum,
            rentType: this.form.mode,
            brandName: this.form.shopName,
            type:this.form.clownes.join(",")
        }
        this.form.shopCode = this.form.shopNum
        publicExport("/api/export/exportMonthSum", obj, "运营收入");
      },
      getAll() {
        //获取表格数据
        if (this.queryDate && this.queryDate.length == 2) {
          this.form.startDate = this.queryDate[0];
          this.form.endDate = this.queryDate[1];
        } else {
          this.form.startDate = "";
          this.form.endDate = "";
        }
        this.loading = true;
        this.$http.post("/api/shopPay/queryShopPay", this.form).then((res) => {
          this.loading = false;
          console.log(res, 'res');
          if (res.data.code == 0) {
            this.count = res.data.data.totalNum;
            this.data = res.data.data.items;
            this.tongjiJson = res.data.data.tongjiJson;
          }
        });
      },
    },
  };
  </script>
  
  <style scoped="scoped">
  .box {
    font-size: 16px;
    width: 70%;
  }
  
  .box > div {
    margin-bottom: 10px;
  }
  </style>
  